export type RpcAuthParams = { token: string; provider: string }

const isLocalDevServer = process.env.NODE_ENV === 'development'

/** Credentials for `rpcLogin` and `ditto.auth.login`. */
export const getRpcAuthParams = async (
  jwtToken: () => Promise<string>,
): Promise<RpcAuthParams> =>
  isLocalDevServer
    ? { token: 'full_access', provider: 'dummy-provider' }
    : { token: (await jwtToken()) || '', provider: 'portal' }
